module.exports = __webpack_public_path__ + "img/9_56.1937ca5f.png";